import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { APP_TOP_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import {
  NAMESPACE_NAVIGATION,
  NavigationConfigurationKeys,
  NavigationConfigurations,
  selectConfigurationValueFrom,
} from '@epicuro-next/platform/configuration';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs';

export const offboardingDeactivateGuard: CanDeactivateFn<unknown> = (
  _,
  __: ActivatedRouteSnapshot,
  ___: RouterStateSnapshot,
  nextState: RouterStateSnapshot,
) => {
  if (nextState.url.includes(APP_TOP_LEVEL_PATH.authentication.path)) {
    return true;
  }
  return inject(Store).pipe(
    select(
      selectConfigurationValueFrom<
        NavigationConfigurationKeys.OffboardingEnabled,
        NavigationConfigurations
      >(
        NAMESPACE_NAVIGATION,
        NavigationConfigurationKeys.OffboardingEnabled,
        false,
      ),
    ),
    map((isOffboardingEnabled) => {
      return isOffboardingEnabled ? false : true;
    }),
  );
};
